import {ListTable} from "./ListTable";
import {transactionList} from "./const";

export const Transaction = ()=>
    <ListTable data={transactionList}/>